/**
 * EmptyFallback — rendered inside the MRT body when the current
 * result set is empty (no data, no filter mismatch). Kept compact —
 * a single dashed card with an inbox glyph and a one-line caption —
 * so it reads as an "empty state" rather than an error.
 *
 * Localisation stays on the legacy `tables` slice for parity with
 * every other table fallback; visuals now use the shared tokens so
 * the card matches the rest of the v3 surface.
 */
import { styled } from '@mui/material/styles';
import { InboxOutlined as InboxIcon } from 'mui/icons';
import { useSelector } from 'react-redux';

const Container = styled('div')({
  position: 'sticky',
  left: '50%',
  right: '50%',
  maxWidth: 1,
});

const Content = styled('div')({
  position: 'absolute',
  width: 'max-content',
  transform: 'translate(-50%, 40px)',
  display: 'flex',
  alignItems: 'center',
  gap: 14,
  padding: '120px 200px',
  borderRadius: 12,
  border: '1px dashed var(--qhs-border)',
  background: 'var(--qhs-surface)',
});

const StyledIcon = styled(InboxIcon)({
  fontSize: 22,
  color: 'var(--qhs-text-3)',
});

const Text = styled('div')({
  fontSize: 13,
  color: 'var(--qhs-text-2)',
  fontFamily: 'var(--qhs-font-body)',
});

const EmptyFallback = () => {
  const { tables } = useSelector(state => state.i18n);

  return (
    <Container className="table-fallback">
      <Content>
        <StyledIcon />
        <Text>{tables?.noRecordsToDisplay || 'No records to display'}</Text>
      </Content>
    </Container>
  );
};

export default EmptyFallback;
